/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { ProductVariantsDropdownProps } from './product-variants-dropdown-type';
import { ProductQuantityDropdown } from '../product-quantity-dropdown';
import styles from './product-variants-dropdown-component.module.css';

export const ProductVariantsDropdown: React.FC<ProductVariantsDropdownProps> = ({
    variants,
    onChange,
}: ProductVariantsDropdownProps) => {
    return (
        <div className={styles.variantsContainer}>
            <div
                className={styles.variants}
                style={{
                    overflowY: 'scroll',
                }}
            >
                {/* <div>
                <div>Quantité</div>
                <div>Prix unitaire</div>
            </div> */}
                {variants.map((variant, index) => {
                    // eslint-disable-next-line react/no-array-index-key
                    return <ProductQuantityDropdown key={index} variant={variant} onChange={onChange} />;
                })}
            </div>
        </div>
    );
};
